module.exports = __webpack_public_path__ + "log white-5507b9aca70f2a95a10b.svg";